import { RecommendationsList } from "@/components/results/RecommendationsList";
import { ReviewTable } from "@/components/results/ReviewTable";
import { SummaryCard } from "@/components/results/SummaryCard";
import {
  hasReviewConfiguration,
  ReviewConfigurationCard,
} from "@/components/review/ReviewConfigurationCard";
import type { ReviewReport, ReviewRow } from "@/types";
import { CanvasSplitBody, CanvasSplitHeader, type CanvasSize } from "./elements/canvas-split";

export type ReviewCanvasDocument = ReviewReport & {
  reviewId: string;
  fileName: string;
  contractType?: string | null;
  jurisdiction?: string | null;
  userRole?: string | null;
  skipResearch?: boolean | null;
  backgroundInfo?: string | null;
  agentInstructions?: string | null;
};

export function ReviewResultsCanvas({
  document,
  writing = false,
  size = "docked",
  onSize,
  onClose,
}: {
  document: ReviewCanvasDocument;
  writing?: boolean;
  size?: CanvasSize;
  onSize?: () => void;
  onClose: () => void;
}) {
  const rows: ReviewRow[] = document.reviewTable;
  const showConfig = hasReviewConfiguration(document);
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col">
      <CanvasSplitHeader
        title={document.fileName || "Contract review"}
        size={size}
        onSize={onSize}
        onClose={onClose}
      />
      <CanvasSplitBody writing={writing}>
        <div className="space-y-6 pt-4 sm:pt-5">
          {showConfig ? (
            <section className="space-y-2">
              <ReviewConfigurationCard
                reviewId={document.reviewId}
                contractType={document.contractType}
                jurisdiction={document.jurisdiction}
                userRole={document.userRole}
                skipResearch={document.skipResearch}
                backgroundInfo={document.backgroundInfo}
                agentInstructions={document.agentInstructions}
              />
            </section>
          ) : null}
          <section className="space-y-2">
            <SummaryCard summary={document.summary} overallRiskScore={document.overallRiskScore} />
          </section>
          <section className="min-w-0 space-y-2">
            <ReviewTable rows={rows} />
          </section>
          {document.recommendations.length > 0 ? (
            <section className="space-y-2">
              <h3 className="text-sm font-semibold text-[#101828] dark:text-white">Recommendations</h3>
              <RecommendationsList recommendations={document.recommendations} />
            </section>
          ) : null}
        </div>
      </CanvasSplitBody>
    </div>
  );
}
